<template>
  <div v-cloak>
    <template>
      <div class="modal" ref="modal" :class="[ isActive ? 'is-active' : '', textClass ]">
        <div class="modal-background" @click="onClose()"></div>
        <div class="modal-card">
          <button
            class="modal-close is-large"
            @click="onClose()"
            aria-label="close"
          ></button>
          <div class="modal-card-body">
            <slot :toggle="onClose" />
          </div>
        </div>
      </div>
    </template>
    <a
      v-if="showButton && !isActive "
      :class="classButton"
      @click="onOpen"
      v-html="contentButton"
    />
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    value: {
      type:Boolean,
      default: null
    },
    showButton: {
      type:Boolean,
      default: true
    },
    textButton: {
      type: String,
      default: "Submit",
    },
    classButton: {
      type: String,
      default: "button is-primary",
    },
    classButtonText: {
      type: String,
      default: "has-text-white",
    },
    iconClass: {
      type: String,
      default: "",
    },
    openToLoad: {
      type: Boolean,
      required: false,
    },
    textClass: {
      type: String,
      default: 'has-text-blue-darkest'
    }
  },
  data() {
    return {
      active: false
    };
  },
  mounted() {
    this.active = !(
      typeof this.openToLoad === "undefined" || this.openToLoad === false
    );

    document.body.insertBefore(this.$refs['modal'], null)
  },
  computed: {
    isActive(){
      return typeof this.value == 'boolean' ? this.value : this.active;
    },
    contentButton() {
      return this.iconClass.length === 0
        ? this.textButton
        : `<i class="${this.iconClass} ${this.classButtonText}"></i><span class="${this.classButtonText}">${this.textButton}</span>`;
    },
  },
  methods: {
    onOpen(){
      this.active = true;
      this.$emit('input', true);
    },
    onClose() {
      this.active = false;
      this.$emit('input', false);
      this.$emit("close")
    },
  },
};
</script>
